import type { RecordMutationErrorResponse } from '../@types/records';

/**
 * Extracts the error message from various error object structures.
 *
 * @param err - The error object or string to parse.
 * @param defaultMessage - The fallback message returned when no specific error message can be extracted. Defaults to 'Unknown error'.
 * @returns A string representation of the error message, or 'Unknown error' if extraction fails.
 */
export function extractErrorMessage(err: unknown, defaultMessage: string = 'Unknown error'): string {
  if (typeof err === 'string') return err;
  if (!err || typeof err !== 'object') return 'Invalid or missing error information';

  const error = err as ApiError;

  if (error.name === 'AbortError') return 'Request was aborted';

  return (
    error.data?.validation?.errorMessage ??
    error.data?.validation?.responseErrors?.[0]?.message ??
    error.data?.validation?.errors?.[0] ??
    error.data?.result?.[0]?.error ??
    error.data?.message ??
    error.error ??
    error.message ??
    defaultMessage
  );
}

// possible error structures type
type ApiError = Partial<RecordMutationErrorResponse> & {
  name?: string;
  message?: string;
  error?: string;
  data?: {
    message?: string;
  };
};
